import { Injectable } from '@angular/core';
import { select, Store } from '@ngrx/store';

import { PersonnelActions, PersonnelInitProps, SetCurrentPersonnelProps } from './personnel.actions';
import * as PersonnelSelectors from './personnel.selectors';
import { PersonnelEntity } from './personnel.entity';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class PersonnelFacade {
  /**
   * Combine pieces of state using createSelector,
   * and expose them as observables through the facade.
   */
  loaded$ = this.store.pipe(select(PersonnelSelectors.getPersonnelLoaded));
  allPersonnel$ = this.store.pipe(select(PersonnelSelectors.getAllPersonnel));
  allPersonnelEntities$ = this.store.pipe(select(PersonnelSelectors.getPersonnelEntities));
  selectedPersonnel$ = this.store.pipe(select(PersonnelSelectors.getSelected));

  constructor(private readonly store: Store) {}

  /**
   * Use the initialization action to perform one
   * or more tasks in your Effects.
   */
  init(props: PersonnelInitProps): void {
    this.store.dispatch(PersonnelActions.init(props));
  }

  setCurrentPersonnel(props: SetCurrentPersonnelProps): void {
    this.store.dispatch(PersonnelActions.setCurrentPersonnel(props));
  }

  getPersonnelById(id: string): Observable<PersonnelEntity | undefined> {
    return this.store.pipe(select(PersonnelSelectors.getPersonnelById(id)));
  }
}
